'use strict';

var privatePropertyAccessor = require('../../common/internal/privatePropertyAccessor');

module.exports = privatePropertyAccessor('lock');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/var/_lock.js
// module id = 299
// module chunks = 0